import gql from 'graphql-tag';

export const productFragment = gql`
fragment ListClientProductPageClientProduct on ClientProduct {
  id
  name
  intrackProduct {
    id
    name
  }
}
`;

export const getClientQL = gql`
query ($clientId: ID!) {
  client(id: $clientId) {
    id
    country
    name
    products {
      id
      ...ListClientProductPageClientProduct
    }
  }
}
${productFragment}
`;
